const comments = [
  {
    name: '追剧小达人',
    avatar: 'ri-user-3-line',
    time: '2小时前',
    text: '777影院真的太良心了！高清画质还完全没有广告，看《庆余年2》全程无打扰，比某些需要充会员的平台好太多了。资源更新速度也快，好评！',
    likes: '1.2k',
  },
  {
    name: '电影控阿杰',
    avatar: 'ri-user-4-line',
    time: '5小时前',
    text: '用了三个月了，片库真的很全，连一些冷门纪录片都能找到。4K超清画质看院线大片真的太爽了，多线路切换功能也很实用，再也不怕卡顿了。',
    likes: '896',
  },
  {
    name: 'Rachel_影视',
    avatar: 'ri-user-5-line',
    time: '昨天',
    text: 'APP端体验极佳，界面简洁没有乱七八糟的推荐。离线缓存功能在通勤路上太方便了，每天地铁上追一集《墨雨云间》，画质清晰流畅。',
    likes: '672',
  },
  {
    name: '老张爱看剧',
    avatar: 'ri-user-2-line',
    time: '2天前',
    text: '朋友推荐的777影院，一开始还不太相信免费能有这质量，试了之后真香。韩剧美剧都有中文字幕，更新也很及时，已经安利给全家人了。',
    likes: '543',
  },
  {
    name: '深夜放映室',
    avatar: 'ri-user-6-line',
    time: '3天前',
    text: '作为一个影视博主，777影院的资源深度让我惊喜。不仅热播剧更新快，很多经典老片也能找到高清修复版。无广告纯净观影体验是最大亮点。',
    likes: '428',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">用户评价</h2>
          <span className="text-xs text-foreground-500 bg-background-800/70 px-3 py-1 rounded-full">真实反馈</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className={`p-5 rounded-2xl bg-background-800/20 border border-background-700/20 ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-500/15 flex items-center justify-center">
                  <i className={`${item.avatar} text-accent-400 text-sm`}></i>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-foreground-200">{item.name}</div>
                  <div className="text-xs text-foreground-600">{item.time}</div>
                </div>
                <div className="flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-thumb-up-line text-accent-400"></i>
                  <span>{item.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}